import ShotHeader from "./ShotHeader";

export default ShotHeader;
